import { HoverCardProps } from '@gate/gui'
import { FC, useMemo, useState } from 'react'
import { useAdapter } from '@/components/Adapter'
// import { observer } from 'mobx-react-lite'
import { BaseHoverCardStyled } from './style'

const BaseHoverCard: FC<HoverCardProps & { isArrow?: boolean; gate_id?: string }> = ({
  isArrow,
  children,
  label,
  styles,
  ...props
}) => {
  const bg = 'var(--color-card-3)'
  const { isH5 } = useAdapter()

  const dropdownStyles = useMemo<any>(() => {
    if (isH5) {
      return {
        zIndex: '600 !important',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100% !important',
        top: 'auto !important',
        height: 'max-content',
        boxShadow: '8px 7px 7px 7px #0D1F4230',
      }
    }
    return {}
  }, [isH5])

  const [opened, setOpened] = useState(false)

  return (
    <BaseHoverCardStyled
      withinPortal
      offset={-4}
      onClose={() => void setOpened(false)}
      onOpen={() => void setOpened(true)}
      closeDelay={0}
      openDelay={0}
      key={isH5 ? 'h5' : 'pc'}
      position="bottom-end"
      label={label}
      styles={{
        ...styles,
        arrow: {
          display: isArrow ? 'block' : 'none',
          ...((styles as any)?.arrow ?? {}),
        },
        dropdown: {
          display: opened ? 'block' : 'none',
          background: bg,
          padding: 0,
          boxShadow: '0px 7px 20px 0px #0D1F4212',
          ...((styles as any)?.dropdown ?? {}),
          zIndex: '1 !important',
          ...dropdownStyles,
        },
      }}
      {...props}
    >
      {children}
    </BaseHoverCardStyled>
  )
}

export default BaseHoverCard
